module.exports = __webpack_public_path__ + "img/key.59250440.jpg";